// Initek dev team profile photos from initekconsulting.com/about-us.
// Images are bundled under /public/team/ for stable URLs in the app.
export const INITEK_TEAM_MEMBERS = [
  { user: 'ben', usernames: ['ben@initekconsulting.com'], name: "Ben O'Day", image: '/team/ben.png' },
  { user: 'jen', usernames: ['jen'], name: 'Jen Mayer', image: '/team/jen.png' },
  { user: 'chaz', usernames: ['chaz@initekconsulting.com'], name: 'Chaz Watson', image: '/team/chaz.jpg' },
  { user: 'kai', usernames: ['kai@initekconsulting.com'], name: 'Kai Klein', image: '/team/kai.png' },
  { user: 'evan', usernames: ['evan@initekconsulting.com'], name: 'Evan Anderson', image: '/team/evan.png' },
]

export function initekTeamImageForUsername(username) {
  if (!username) return null
  const normalized = String(username).toLowerCase()
  const member = INITEK_TEAM_MEMBERS.find(m =>
    m.usernames.some(value => value.toLowerCase() === normalized)
  )
  return member ? member.image : null
}

// Filter chips on the support ticket list (active-ticket shortcuts).
export const INITEK_TEAM_FILTER_CHIPS = INITEK_TEAM_MEMBERS.filter(m =>
  ['ben', 'jen', 'chaz', 'kai', 'evan'].includes(m.user)
)
